/**
 * HeroSplit Section
 * Раздельный hero: изображение с одной стороны, текст с другой
 */
import { Text, Button, Image, Container } from '../components';

const heightClasses = {
  small: 'min-h-[400px] md:min-h-[450px]',
  medium: 'min-h-[500px] md:min-h-[550px]',
  large: 'min-h-[600px] md:min-h-[650px]',
  fullscreen: 'min-h-screen',
};

const verticalAlignClasses = {
  top: 'justify-start',
  center: 'justify-center',
  bottom: 'justify-end',
};

export default function HeroSplitSection({ data, styles }) {
  const imagePosition = data?.imagePosition || 'right';
  const height = data?.height || 'large';
  const verticalAlign = data?.verticalAlign || 'center';
  const buttons = data?.buttons || [];

  const isImageLeft = imagePosition === 'left';

  return (
    <section
      className={`relative ${heightClasses[height] || heightClasses.large}`}
      style={{
        paddingTop: styles?.paddingTop ?? 64,
        paddingBottom: styles?.paddingBottom ?? 64,
        backgroundColor: styles?.backgroundColor || '#ffffff'
      }}
    >
      <Container className="h-full">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-8 lg:gap-12 h-full">
          {/* Image Side */}
          {data?.image && (
            <div
              className={`relative min-h-[300px] lg:min-h-full ${isImageLeft ? 'order-1 lg:order-1' : 'order-1 lg:order-2'}`}
            >
              <Image
                src={data.image}
                alt={data?.title?.text || data?.title || ''}
                className="absolute inset-0 w-full h-full rounded-lg lg:rounded-2xl overflow-hidden"
                fit="cover"
                loading="eager"
              />
            </div>
          )}

          {/* Content Side */}
          <div
            className={`flex flex-col ${verticalAlignClasses[verticalAlign] || verticalAlignClasses.center} ${isImageLeft ? 'order-2 lg:order-2' : 'order-2 lg:order-1'}`}
          >
            <div className="max-w-lg">
              {/* Заголовок */}
              <Text
                as="h1"
                data={typeof data?.title === 'object' ? data.title : { text: data?.title }}
                defaults={{ size: '4xl', weight: 'bold', color: 'inherit' }}
                className="mb-4 md:mb-6"
              />

              {/* Подзаголовок */}
              {(data?.subtitle?.text || data?.subtitle) && (
                <Text
                  as="p"
                  data={typeof data?.subtitle === 'object' ? data.subtitle : { text: data?.subtitle }}
                  defaults={{ size: 'lg', weight: 'normal', color: 'secondary' }}
                  className="mb-6 md:mb-8"
                />
              )}

              {buttons.length > 0 && (
                <div className="flex flex-col sm:flex-row gap-3 md:gap-4">
                  {buttons.map((button, index) => {
                    const textData = typeof button.text === 'object' ? button.text : { text: button.text || '' };
                    return (
                      <Button
                        key={button.id || index}
                        href={button.link || '#'}
                        variant={button.variant || 'primary'}
                        size="lg"
                      >
                        <Text
                          as="span"
                          data={textData}
                          defaults={{ size: 'base', weight: 'medium', color: 'inherit' }}
                        />
                      </Button>
                    );
                  })}
                </div>
              )}
            </div>
          </div>
        </div>
      </Container>
    </section>
  );
}
